export default __webpack_public_path__ + "static/media/027-camera.89110602.svg";